<template>
  <div class="school-home-page">
    <div class="frame">
      <div class="menu" style="background: #fff;">
        <el-row>
          <el-col :span="24">
            <div class="logo_wrapper">
              <el-row>
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <!-- 头像 -->
                    <!-- <img
                      class="image-url"
                      v-if="$store.state.resource.imageUrl"
                      :src="$store.state.resource.imageUrl"
                      alt=""
                    /> -->
                    <!-- 头像挂件 -->
                    <img class="title-url" v-if="$store.state.resource.titleUrl" :src="$store.state.resource.titleUrl" alt="" />
                    <el-image class="logo_img" :src="
                        $store.state.user.userInfo.headimgUrl +
                          '?x-oss-process=image/resize,m_fill,h_100,w_100'
                      " fit="fill"></el-image>
                  </div>
                </el-col>
              </el-row>

              <!-- <el-row>
                <el-col :span="24">
                  <div class="logo_name">
                    <el-tooltip effect="dark" :content="'账号:' + $store.state.user.userInfo.name" placement="top-start">
                      <span>{{
                        $store.state.user.userInfo.realName &&
                        $store.state.user.userInfo.realName.length > 4
                          ? $store.state.user.userInfo.realName.slice(0, 4) +
                            '...'
                          : $store.state.user.userInfo.realName
                      }}</span>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row> -->

              <el-row>
                <el-col :span="24">
                  <!-- 学生端的左侧 -->
                  <div class="stu-name">
                    {{$store.state.user.username}}
                  </div>
                  <div class="logo_school">
                    {{ $store.state.user.schoolInfo.name }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-menu :default-active="activeMenu" class="el-menu-demo" background-color="#ffffff" text-color="#333333" active-text-color="#383838">
          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="classroomIndexStu" @click="$router.push({ name: 'classroomIndexStu' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-s-home"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">教室首页</span>
            </el-menu-item>
          </div>

          <!--
          <el-menu-item index="classlistIndexStu" @click="$router.push({ name: 'classlistIndexStu' })">
            <i style="margin-left: 40px; font-size: 22px" class="el-icon-s-custom"></i>
            <span style="font-size: 16px" slot="title">我的课程</span>
          </el-menu-item>
-->
          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="classlistIndexStu1" @click="$router.push({ name: 'classlistIndexStu1' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-notebook-2"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">学习中心</span>
            </el-menu-item>
          </div>
          <!-- <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item
              index="classIndexSstu"
              @click="$router.push({ name: 'classIndexSstu' })"
            >
              <i
                style="margin-left: 20px; font-size: 22px"
                class="el-icon-user"
              ></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title"
                >我的班级</span
              >
            </el-menu-item>
          </div> -->

          <el-submenu index="stuworks">
            <template slot="title">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-menu"></i>
              <span style="margin-left: 10px;font-size: 16px">作品管理</span>
            </template>
            <!-- <el-menu-item
              v-if="$store.state.user.userInfo.zoneAuth"
              index="classlistWorksStudent"
              @click="$router.push({ name: 'classlistWorksStudent' })"
            >
              <span style="margin-left: 40px">班级作品</span>
            </el-menu-item> -->
            <el-menu-item index="classlistStuWorks" @click="$router.push({ name: 'classlistStuWorks' })">
              <span style="margin-left: 40px">课堂作品</span>
            </el-menu-item>
            <el-menu-item index="freeCreation" @click="$router.push({ name: 'freeCreation' })">
              <span style="margin-left: 40px">自由创作</span>
            </el-menu-item>
          </el-submenu>

          <div style="padding-left: 10px;padding-right: 10px;" v-if="$store.state.user.schoolInfo.pointAuth">
            <el-menu-item index="stuStarCoinCenter" @click="$router.push({ name: 'stuStarCoinCenter' })">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-star-off"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">星币中心</span>
            </el-menu-item>
          </div>

          <!-- 添加打字星球菜单项 -->
          <div style="padding-left: 10px;padding-right: 10px;">
            <el-menu-item index="typingPlanet" @click="goToTypingPlanet">
              <i style="margin-left: 20px; font-size: 22px" class="el-icon-position"></i>
              <span style="margin-left: 10px;font-size: 16px" slot="title">打字星球</span>
            </el-menu-item>
          </div>

        </el-menu>
      </div>
      <section>
        <container></container>
      </section>
    </div>
  </div>
</template>

<script>
import container from './container'

export default {
  name: 'index-stu',
  components: {
    container,
  },
  data() {
    return {}
  },

  computed: {
    activeMenu() {
      const route = this.$route
      const { meta, name } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return name
    },
  },

  mounted() {
    document.getElementById('home_top').style.display = 'block'
    document.getElementById('home_bottom').style.display = 'none'
    // this.$store.dispatch('getStuTitleUrl')
  },

  methods: {
    goToTypingPlanet() {
      this.$router.push({ name: 'TypingPlanet' })
    }
  },
}
</script>

<style>
.header-menu-container {
  display: none;
}

.el-submenu {
  /* min-width: 220px; */
}

.school-home-page .frame section::-webkit-scrollbar {
  /* display: none; */
}
</style>

<style scoped lang="scss">
.school-home-page {
  height: calc(100% - 60px);

  .logo_wrapper {
    position: relative;
    width: 220px;
    height: 250px;
    background: #ffffff;
    color: #707070;
    .image-url,
    .title-url {
      position: absolute;
      z-index: 2;
      width: 220px;
      left: 0px;
      top: 0px;
    }
    .logo_img {
      position: relative;
      z-index: 1;
      border-radius: 50%;
      width: 100px;
      height: 100px;
      margin-left: 60px;
      margin-top: 60px;
    }

    .logo_name {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
    }

    .stu-name {
      padding-top: 20px;
      padding-bottom: 5px;
      text-align: center;
    }
    .logo_school {
      text-align: center;
    }
  }

  .frame {
    display: flex;
    width: 100%;
    height: 100%;
    background: #f1f7fe;

    .menu {
      position: relative;
      z-index: 100;
      overflow: hidden;
      width: 220px;
      /*box-shadow: 0 -8px 10px 2px #dedee3;*/

      header {
        height: 30px;
      }

      .header-title {
        padding: 5px 0;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }

      .el-menu-demo:not(.el-menu--collapse) {
        width: 220px;
      }

      .el-menu-demo {
        height: calc(100% - 250px);
      }

      .el-submenu {
        // min-width: 220px;
      }

      .el-menu-item {
        // min-width: 220px;
      }

      .el-menu-item.is-active {
        background-color: #e1edff !important;
      }

      /deep/.el-menu-demo .el-submenu {
        margin-left: 10px !important;
        margin-right: 10px !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
        min-width: auto;
        line-height: 50px !important;
      }

      /deep/.el-menu-demo .el-menu-item {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item:hover {
        outline: 0 !important;
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      /deep/.el-menu .el-menu-item.is-active {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }

      .el-submenu /deep/.el-submenu__title:hover {
        color: #2e95fb !important;
        background: linear-gradient(
          270deg,
          #f2f7fc 100%,
          #fefefe 0%
        ) !important;
        border-radius: 10px !important;
      }
    }

    section {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
